<template>
    <div id="container">
<div id="content">
            <el-form v-if="semesters.length" class="term-select" label-position="left">
                <el-form-item label="Term:" >
                    <el-select style="width:150px;" size="mini" v-model="semesterId" @change="getRequests">
                        <el-option v-for="semester in semesters" :key="semester.id" :value="semester.id" :label="semester.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <h1>Pending E-Text requests - Need reading list</h1>
            <etext-service-nav selected="unfilled-requests"></etext-service-nav>
            <p>To enter a reading list, click on the course name.</p>
            <el-table :default-sort="{prop: 'student_name', order: 'ascending'}" :data="requests" class="table-top-align">
                <el-table-column label="Name" prop="student_name" sortable :sort-orders="['ascending', 'descending']" width="215">
                    <template slot-scope="scope">
                        <a :href="'/student/services/' + scope.row.student_id">{{ scope.row.student_name }}</a>
                    </template>
                </el-table-column>
                <el-table-column label="Preferred name" prop="student_preferred_name" sortable :sort-orders="['ascending', 'descending']" width="155"></el-table-column>
                <el-table-column label="Course name" prop="class_name" sortable :sort-orders="['ascending', 'descending']" width="155">
                    <template slot-scope="scope">
                        <a :href="'/etext-service/show/' + scope.row.id">{{ scope.row.class_name }}</a>
                    </template>
                </el-table-column>
                <el-table-column label="Emailed advisor" prop="emailed_advisor_date" sortable :sort-orders="['ascending', 'descending']" width="80">
                    <template slot-scope="scope">{{ scope.row.emailed_advisor_date | formatDateMD }}</template>
                </el-table-column>
                <el-table-column label="Emailed student" prop="emailed_student_date" sortable :sort-orders="['ascending', 'descending']" width="80">
                    <template slot-scope="scope">{{ scope.row.emailed_student_date | formatDateMD }}</template>
                </el-table-column>
                <el-table-column label="Emailed professor" prop="emailed_student_date" sortable :sort-orders="['ascending', 'descending']" width="80">
                    <template slot-scope="scope">{{ scope.row.emailed_student_date | formatDateMD }}</template>
                </el-table-column>
                <el-table-column label="Emailed department chair" prop="emailed_dept_date" sortable :sort-orders="['ascending', 'descending']" width="90">
                    <template slot-scope="scope">{{ scope.row.emailed_dept_date | formatDateMD }}</template>
                </el-table-column>
                <el-table-column label="Checked Courseworks" prop="checked_courseworks_date" sortable :sort-orders="['ascending', 'descending']" width="100">
                    <template slot-scope="scope">{{ scope.row.checked_courseworks_date | formatDateMD }}</template>
                </el-table-column>
                <el-table-column label="Accommodations" prop="accommodations" sortable :sort-orders="['ascending', 'descending']">
                    <template slot-scope="scope">
                        <template v-for="accommodation in scope.row.accommodations">
                            {{ accommodation.name }}<template v-if="accommodation.description"> - {{ accommodation.description }}</template><template v-if="accommodation.comment"> - <span v-html="accommodation.comment" :key="accommodation.id"></span></template>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <p v-if="total">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ({{ total }} records)</p>
        </div>
        </div>
</template>

<script>
    import axios from 'axios'


    export default {
        metaInfo () {
            return {
                title: "Pending E-Text requests - Need reading list"
            }
        },
        components: {
        },
        data () {
            return {
                requests: [],
                semesters: [],
                semesterId: null,
                total: null
            }
        },
        methods: {
            load: function() {
                axios.get('/api/simple/get-current-and-past-semesters')
                    .then(response => {
                        this.semesters = response.data.rows;
                        for(var i = 0; i < this.semesters.length; i++){
                            if(this.semesters[i].is_current){
                                this.semesterId = this.semesters[i].id;
                            }
                        }
                        this.getRequests();
                    });
            },
            getRequests: function() {
                axios.get('/api/etext-service/unfilled-requests/', {params: {semester_id: this.semesterId}})
                    .then(response => {
                        if(response.data.success) {
                            this.requests = response.data.rows;
                            this.total = response.data.total;
                        }
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
            }
        },
        created () {
            this.load();
        }
    }
</script>
<style scoped>
    .term-select {
        width: 250px;
        float:right;
    }
    .el-table th {
        vertical-align: top;
    }
</style>
